import React from 'react';
import '../less/main.less';
import DOMPurify from 'utils/sanitize';

export default function template() {
  const { title, className, tag = 'h2' } = this.props;

  const Tag = tag;

  return (
    <div className={`title-block-new${className ? ` ${className}` : ''}`}>
      <div className="container">
        <Tag className="title-block-new__body" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(title))}}></Tag>
      </div>
    </div>
  );
}

